import React from 'react';

import type { Order } from '@src/domains/orders';
import type { Sale, SaleChange } from '@src/domains/sales';
import { useTranslate } from '@src/core/hooks';
import {
  SummaryHeaderCard,
  SummaryHeaderProductCount,
  SummaryHeaderTitle,
  SummaryHeaderTitleRow,
  SummaryItemsList,
  SummaryRoot,
} from '@src/features/cart';

import { useSaleChangeSummary } from '../hooks/useSaleChangeSummary';
import { SaleChangeSummaryTotal } from './SaleChangeSummaryTotal';

type SaleChangeSummaryProps = {
  saleChange: SaleChange;
  sale?: Sale | null;
  order?: Order | null;
  showItems?: boolean;
};

export const SaleChangeSummary = (props: SaleChangeSummaryProps) => {
  const { saleChange, sale, order, showItems = true } = props;
  const { i18n } = useTranslate();
  const summary = useSaleChangeSummary(saleChange, sale, order);

  return (
    <SummaryRoot data-testid='sale-change-summary'>
      <SummaryHeaderCard>
        <SummaryHeaderTitleRow>
          <SummaryHeaderTitle>{i18n('checkout_order_summary_title')}</SummaryHeaderTitle>
          <SummaryHeaderProductCount>
            {i18n('checkout_cart_summary_products', { count: summary.productCount })}
          </SummaryHeaderProductCount>
        </SummaryHeaderTitleRow>

        <SaleChangeSummaryTotal summary={summary} />
      </SummaryHeaderCard>

      {showItems ? <SummaryItemsList items={summary.items} /> : null}
    </SummaryRoot>
  );
};

export default SaleChangeSummary;
